//reblem12/src/pages/Auth/Register.js
import React, { useState, useEffect } from 'react';
import './Register.css';
import { useLanguage } from '../../context/LanguageContext';
import { getTranslation } from '../../i18n/translations';

const Register = ({ onRegister, onNavigateToLogin, onNavigateToDashboard }) => {
  const { language } = useLanguage();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  

   
  const API_BASE_URL = 'https://cp.fxpool.io/api';
  

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const validatePassword = (password) => {
    return password.length >= 8 && 
           /[A-Z]/.test(password) && 
           /[a-z]/.test(password) && 
           /[0-9]/.test(password);
  };

  // Update the sendOtpEmail function:
  const sendOtpEmail = async (email, otpCode) => {
    try {
     // console.log('Sending OTP to:', email, 'Code:', otpCode);
      
      const response = await fetch(`${API_BASE_URL}/send-otp.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          otp: otpCode,
          subject: 'Your OTP Code - FX-Pool',
        }),
      });

      //console.log('Response status:', response.status);
      const data = await response.json();
      //console.log('Response data:', data);
      
      if (data.success) {
        // For development, show OTP in console/alert
       // console.log(`Development OTP for ${email}: ${otpCode}`);
       // alert(`Development mode: OTP sent to ${email}\nOTP: ${otpCode}\nCheck console for details.`);
      }
      
      return data.success;
    } catch (error) {
    //  console.error('Error sending OTP:', error);
      // For development, still allow OTP to be used
     // console.log(`Development OTP for ${email}: ${otpCode}`);
    //  alert(`Development mode: OTP would be sent to ${email}\nOTP: ${otpCode}\nEnable CORS for production.`);
      return true; // Allow in development
    }
  };

  // Send OTP when step changes to 2
  useEffect(() => {
    if (step === 2 && !otpSent) {
      handleSendOtp();
    }
  }, [step]);

  const handleSendOtp = async () => {
    if (!email) return;
    
    setLoading(true);
    // Generate OTP
    const generatedOtp = Math.floor(100000 + Math.random() * 900000).toString();
   
    
    try {
      // Send OTP via email
      const sent = await sendOtpEmail(email, generatedOtp);
      
      if (sent) {
        setOtpSent(true);
        setResendCooldown(60);
        
        // Start cooldown timer
        const timer = setInterval(() => {
          setResendCooldown((prev) => {
            if (prev <= 1) {
              clearInterval(timer);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        setErrors({ otp: 'Failed to send OTP. Please try again.' });
      }
    } catch (error) {
      setErrors({ otp: 'Error sending OTP. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const validateStep1 = () => {
    const newErrors = {};
    
    if (!email) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(email)) {
      newErrors.email = 'Email is invalid';
    }
    
    if (!acceptTerms) {
      newErrors.terms = 'You must accept the Terms of Use and Privacy Policy';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    const newErrors = {};
    
    if (!otp) {
      newErrors.otp = 'OTP is required';
    } else if (otp.length !== 6) {
      newErrors.otp = 'OTP must be 6 digits';
     
 
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep3 = () => {
    const newErrors = {};
    
    if (!password) {
      newErrors.password = 'Password is required';
    } else if (!validatePassword(password)) {
      newErrors.password = 'Password must be at least 8 characters with uppercase, lowercase, and number';
    }
    
    if (!confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your password';
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Update the handleStep1 function:
  const handleStep1 = async (e) => {
    e.preventDefault();
    
    if (!validateStep1()) {
      return;
    }

    setLoading(true);
    
    // Skip database check for demo - just proceed to OTP
    setTimeout(() => {
      setLoading(false);
      setStep(2);
    }, 500);
    
   
    try {
      const formData = new FormData();
      formData.append('email', email);
      
      const response = await fetch(`${API_BASE_URL}/check-email.php`, {
        method: 'POST',
        body: formData,
      });
      
      const data = await response.json();
      
      if (data.exists) {
        setErrors({ email: 'Email already registered. Please log in.' });
        setLoading(false);
        return;
      }
      
      // Proceed to OTP step
      setTimeout(() => {
        setLoading(false);
        setStep(2);
      }, 500);
      
    } catch (error) {
      console.error('Error checking email:', error);
      setLoading(false);
      // Proceed anyway for demo purposes
      setTimeout(() => {
        setStep(2);
      }, 500);
    }
  
  };

  // Update the handleStep2 function:
 const handleStep2 = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const response = await fetch(`${API_BASE_URL}/verify-otp.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, otp }),
    });
    
    const data = await response.json();

    if (data.verified) {
      setLoading(false);
      setStep(3); // Move to password step only after backend verification
    } else {
      setErrors({ otp: data.message || 'Invalid OTP. Please try again.' });
      setLoading(false);
    }
  } catch (error) {
    //console.error('OTP verification error:', error);
    setErrors({ otp: 'Server error. Please try again.' });
    setLoading(false);
  }
};


  // Update the handleStep3 function:
  const handleStep3 = async (e) => {
    e.preventDefault();
    
    if (!validateStep3()) {
      return;
    }

    setLoading(true);
    
    // For demo, create mock user
    setTimeout(() => {
      const mockUser = {
        email: email,
        name: email.split('@')[0],
        token: 'mock-jwt-token-' + Date.now()
      };
      
      localStorage.setItem('authToken', mockUser.token);
      localStorage.setItem('userData', JSON.stringify(mockUser));
      
      if (onRegister) {
        onRegister(mockUser);
      }
      
      if (onNavigateToDashboard) {
        onNavigateToDashboard();
      }
      setLoading(false);
    }, 1000);
    
  
    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);
      formData.append('confirm_password', confirmPassword);
      
      const response = await fetch(`${API_BASE_URL}/register.php`, {
        method: 'POST',
        body: formData,
      });
      
      const data = await response.json();
      
      if (data.success) {
        const user = data.user;
        
        // Store in localStorage
        localStorage.setItem('authToken', user.token);
        localStorage.setItem('userData', JSON.stringify(user));
        
        if (onRegister) {
          onRegister(user);
        }
        
        // Navigate to dashboard after registration
        if (onNavigateToDashboard) {
          onNavigateToDashboard();
        }
      } else {
        setErrors({ form: data.message || 'Registration failed. Please try again.' });
        setLoading(false);
      }
    } catch (error) {
      console.error('Error registering:', error);
      // For demo purposes, create mock user
      const mockUser = {
        email: email,
        name: email.split('@')[0],
        token: 'mock-jwt-token-' + Date.now()
      };
      
      localStorage.setItem('authToken', mockUser.token);
      localStorage.setItem('userData', JSON.stringify(mockUser));
      
      if (onRegister) {
        onRegister(mockUser);
      }
      
      if (onNavigateToDashboard) {
        onNavigateToDashboard();
      }
      setLoading(false);
    }
    
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (step === 1) {
      handleStep1(e);
    } else if (step === 2) {
      handleStep2(e);
    } else if (step === 3) {
      handleStep3(e);
    }
  };

  const handleResendOtp = async () => {
    if (resendCooldown > 0) return;
    
    setLoading(true);
    setOtp('');
    await handleSendOtp();
    setLoading(false);
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
      setErrors({});
      if (step === 2) {
        setOtp('');
      } else if (step === 3) {
        setPassword('');
        setConfirmPassword('');
      }
    }
  };

  const isStep1Valid = email && validateEmail(email) && acceptTerms;
  const isStep2Valid = otp && otp.length === 6;
  const isStep3Valid = password && confirmPassword && validatePassword(password) && password === confirmPassword;

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <form onSubmit={handleStep1} className="reg-block__content-block">
            <div className="reg-block__email">
              <label htmlFor="reg_email" className="reg-block__mail-title">{getTranslation('email', language)}</label>
              <input
                id="reg_email"
                className={`reg-block__email-in ${errors.email ? 'error' : ''}`}
                placeholder={getTranslation('email', language)}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>
            <div className="reg-block__terms">
              <input
                type="checkbox"
                id="terms"
                checked={acceptTerms}
                onChange={(e) => setAcceptTerms(e.target.checked)}
                required
              />
              <label htmlFor="terms" className="reg-block__terms-text">
                {getTranslation('iAcceptThe', language)}{' '}
                <a href="https://fx-pool.com/en/terms-of-use" target="_blank" rel="noopener noreferrer" className="reg-block__terms-link">
                  {getTranslation('termsOfUse', language)}
                </a>{' '}
                {getTranslation('and', language)}{' '}
                <a href="https://fx-pool.com/en/privacy-policy" target="_blank" rel="noopener noreferrer" className="reg-block__terms-link">
                  {getTranslation('privacyPolicy', language)}
                </a>
              </label>
            </div>
            {errors.terms && <span className="error-text">{errors.terms}</span>}
            <button type="submit" className="reg-block__btn" disabled={!isStep1Valid || loading}>
              {loading ? getTranslation('processing', language) : getTranslation('continue', language)}
            </button>
          </form>
        );
      case 2:
        return (
          <form onSubmit={handleStep2} className="reg-block__content-block">
            <div className="reg-step2-info">
              <p className="reg-step2-text">
                {getTranslation('sentVerification', language)} <strong>{email}</strong>
              </p>
              <p className="reg-step2-hint">{getTranslation('enter6Digit', language)}</p>
              <p className="reg-step2-hint-small">Check your inbox and spam folder</p>
               
            </div>
            <div className="reg-block__email">
              <label htmlFor="reg_otp" className="reg-block__mail-title">{getTranslation('otp', language)}</label>
              <input
                id="reg_otp"
                className={`reg-block__email-in otp-in ${errors.otp ? 'error' : ''}`}
                placeholder="------"
                type="text"
                maxLength="6"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                required
              />
              {errors.otp && <span className="error-text">{errors.otp}</span>}
            </div>
            <div className="reg-resend-otp">
              <p className="reg-resend-text">
                {getTranslation('didntReceive', language)}{' '}
                <button
                  type="button"
                  className="reg-resend-button"
                  onClick={handleResendOtp}
                  disabled={resendCooldown > 0 || loading}
                >
                  {loading ? getTranslation('sending', language) : 
                   resendCooldown > 0 ? `${getTranslation('resendIn', language)} ${resendCooldown}s` : 
                   getTranslation('resendOtp', language)}
                </button>
              </p>
            </div>
            <button type="submit" className="reg-block__btn" disabled={!isStep2Valid || loading}>
              {loading ? getTranslation('verifying', language) : getTranslation('verifyOtp', language)}
            </button>
            <button type="button" className="reg-back-button" onClick={handleBack}>
              &larr; {getTranslation('back', language)}
            </button>
          </form>
        );
      case 3:
        return (
          <form onSubmit={handleStep3} className="reg-block__content-block">
            <div className="reg-block__password">
              <label htmlFor="reg_password" className="reg-block__password-title">{getTranslation('password', language)}</label>
              <div className="reg-block__password-wrapper">
                <input
                  id="reg_password"
                  className={`reg-block__email-in ${errors.password ? 'error' : ''}`}
                  placeholder={getTranslation('enterPassword', language)}
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button type="button" className="reg-visibility-icon" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
              {errors.password && <span className="error-text">{errors.password}</span>}
            </div>
            <div className="reg-block__confirm-password">
              <label htmlFor="reg_confirm_password" className="reg-block__password-title">{getTranslation('confirmPassword', language)}</label>
              <div className="reg-block__password-wrapper">
                <input
                  id="reg_confirm_password"
                  className={`reg-block__email-in ${errors.confirmPassword ? 'error' : ''}`}
                  placeholder={getTranslation('confirmPassword', language)}
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <button type="button" className="reg-visibility-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                  {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
              {errors.confirmPassword && <span className="error-text">{errors.confirmPassword}</span>}
            </div>
            <button type="submit" className="reg-block__btn" disabled={!isStep3Valid || loading}>
              {loading ? getTranslation('creatingAccount', language) : getTranslation('createAccount', language)}
            </button>
            <button type="button" className="reg-back-button" onClick={handleBack}>
              &larr; {getTranslation('back', language)}
            </button>
          </form>
        );
      default:
        return null;
    }
  };

  return (
    <div className="reg-group">
      <div className="reg-branding">
        <div className="branding-logo">
          <img src="/Logo.svg" alt="FX-Pool Logo" />
        </div>
        <h1 className="branding-title">{getTranslation('brandingTitle', language)}</h1>
        <p className="branding-subtitle">{getTranslation('brandingSubtitle', language)}</p>
      </div>
      <div className="reg-block">
        <div className="reg-block__top">
          <a href="#" className="reg-block__logo-link">
            <img src="/Logo.svg" alt="FX-Pool logo" />
          </a>
          <div className="title-group">
            <h2 className="title">{getTranslation('signUp', language)}</h2>
            <p className="subtitle">{getTranslation('createAccountSubtitle', language)}</p>
          </div>
          
          <div className="registration-progress">
            <div className="progress-steps">
              <div className="progress-line"></div>
              <div className={`progress-step ${step >= 1 ? 'active' : ''} ${step > 1 ? 'completed' : ''}`}>
                <div className="progress-step-circle">1</div>
                <div className="progress-step-label">{getTranslation('yourDetails', language)}</div>
              </div>
              <div className={`progress-step ${step >= 2 ? 'active' : ''} ${step > 2 ? 'completed' : ''}`}>
                <div className="progress-step-circle">2</div>
                <div className="progress-step-label">{getTranslation('verifyEmail', language)}</div>
              </div>
              <div className={`progress-step ${step >= 3 ? 'active' : ''} ${step > 3 ? 'completed' : ''}`}>
                <div className="progress-step-circle">3</div>
                <div className="progress-step-label">{getTranslation('setPassword', language)}</div>
              </div>
            </div>
          </div>
          
          {renderStepContent()}

          <div className="reg-block__footer">
            <span className="reg-block__footer-text">{getTranslation('alreadyHaveAccount', language)} </span>
            <a href="#" onClick={onNavigateToLogin} className="reg-block__footer-link">{getTranslation('logIn', language)}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;